import React, { FC } from 'react';
import type { ILegoElemProps } from '../../Lego';
import { ILegoElemReactNode } from '../models';
import { Box } from '@src/atoms/Box';

/**
 * Для особых случаев когда проще и лучше прямо закодить какой-то компонент и вставить его в Lego как элемент.
 * Подходит для каких-то баннеров, например.
 */
export const LegoElemReactNode: FC<ILegoElemProps> = ({ elem }) => {
  const reactNodeElem = elem as ILegoElemReactNode;

  // в Box оборачиваем, чтобы точно поставить data-id для тестирования
  // В div нельзя - не всегда нормально срабатывает fullWidth у вложенных Box-ов
  return (
    <Box data-id={elem.id} fullWidth>
      {reactNodeElem.reactNode.content}
    </Box>
  );
};
